import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBody from './FsBody';

const FsBodyBold = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 600,
    },
  })
)((props: TypographyAllProps) => <FsBody {...props} />);

export default FsBodyBold;
